<template>
  <div :class="modalClass">
    <div class="content" @modal-close="toggleModal(name)">
      <span class="close" @click="toggleModal(name)">X</span>
      <h4 style="text-align: center">Add Interested Party</h4>
      <br />
      <div class="field">
        <label class="tinylabel">Name <red v-pre>*</red></label>
        <input v-model="interestedParty.firstName" type="text" />
      </div>
      <br />
      <div class="field">
        <label class="tinylabel">Street Address <red v-pre>*</red></label>
        <input v-model="interestedParty.address.address" type="text" />
      </div>
      <br />
      <div class="field">
        <label class="tinylabel">Apt / Suite</label>
        <input v-model="interestedParty.address.apt" type="text" />
      </div>
      <br />
      <div class="field">
        <label class="tinylabel">City <red v-pre>*</red></label>
        <input v-model="interestedParty.address.city" type="text" />
      </div>
      <br />
      <div class="field">
        <label class="tinylabel">State <red v-pre>*</red> </label>
        <us-states-box v-model="interestedParty.address.state"></us-states-box>
      </div>
      <br />
      <div class="field">
        <label class="tinylabel">Zip <red v-pre>*</red></label>
        <input v-model="interestedParty.address.zip" type="text" />
      </div>
      <div style="clear: both"></div>
      <br /><br /><br />
      <div style="text-align: center">
        <button :disabled="!validated" @click="addInterestedParty()">
          Notify Party
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { InterestedParty } from "@/models/InterestedParty";
import UsStatesBox from "@/components/UsStatesBox.vue";
import { ref, computed, onUnmounted } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import useModal from "@/hooks/useModal";
const props = defineProps({
  name: {
    type: String,
    default: "",
  },
});
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name);
onUnmounted(() => {
  onModalDestroy(props.name);
});
const interestedParty = ref(new InterestedParty());
const quoteStore = useQuoteStore();
const quote = quoteStore;

const addInterestedParty = () => {
  // Emit the newly added user
  quote.checkout.interestedParty = interestedParty.value;
  toggleModal(props.name);
  interestedParty.value = new InterestedParty();
};

const validated = computed(() => {
  return (
    interestedParty.value.firstName &&
    interestedParty.value.address.address &&
    interestedParty.value.address.city &&
    interestedParty.value.address.zip &&
    interestedParty.value.address.state &&
    interestedParty.value.address.state.short
  );
});
</script>
<style scoped>
.content {
  max-width: 400px !important;
}
</style>
